let config

function booleanEnvironmentValue(value, fallback) {
  return value === undefined ? fallback : value === 'true'
}

const editableDefault = false
const editable = booleanEnvironmentValue(process.env.VUE_APP_EDITABLE, editableDefault)
const configuredDataSource = process.env.VUE_APP_DATA_SOURCE
if (configuredDataSource && !['backend', 'static'].includes(configuredDataSource)) {
  throw new Error('VUE_APP_DATA_SOURCE must be either "backend" or "static"')
}
const staticData = configuredDataSource
  ? configuredDataSource === 'static'
  : !editable
if (staticData && editable) {
  throw new Error('The static data source is read-only; set VUE_APP_EDITABLE=false')
}

if (process.env.NODE_ENV == 'production') {
  config = {
    apiUrl: '/api',
    appDomain: 'gallrom.linguistik.uzh.ch',
    apiUrlClientSide: process.env.VUE_APP_STATIC_DATA_URL || 'https://gallrom.linguistik.uzh.ch/data',
    imagesUrl: '/legam_images',
    apiHeaders: {},
    sentryDSN: 'https://7ed838544c1e4519bf3978d420635180@sentry.linguistik.uzh.ch/2',
    editable: editable,
    staticData: staticData,
    dataSource: staticData ? 'static' : 'backend',
    // editable: true,
  }
}
else if (process.env.NODE_ENV == 'test') {
  config = {
    apiUrl: '/api',
    apiUrlClientSide: process.env.VUE_APP_STATIC_DATA_URL || '/data',
    appDomain: 'legamedittest.linguistik.uzh.ch',
    imagesUrl: '/legam_images',
    environment: 'test',
    apiHeaders: {},
    sentryDSN: 'https://7ed838544c1e4519bf3978d420635180@sentry.linguistik.uzh.ch/2',
    // editable: false,
    editable: editable,
    staticData: staticData,
    dataSource: staticData ? 'static' : 'backend',
  }
}
else if (process.env.NODE_ENV == 'staging') {
  config = {
    apiUrl: '/api',
    apiUrlClientSide: process.env.VUE_APP_STATIC_DATA_URL || '/data',
    appDomain: 'legameditnext.linguistik.uzh.ch',
    environment: 'staging',
    apiHeaders: {},
    sentryDSN: 'https://7ed838544c1e4519bf3978d420635180@sentry.linguistik.uzh.ch/2',
    // editable: false,
    editable: editable,
    staticData: staticData,
    dataSource: staticData ? 'static' : 'backend',
  }
}
else {
  // development
  config = {
    apiUrl: 'http://localhost:5001',
    apiUrlClientSide: process.env.VUE_APP_STATIC_DATA_URL || 'http://localhost:5002/data-2026-05',
    imagesUrl: 'http://localhost:8000',
    appDomain: 'localhost',
    environment: 'development',
    apiHeaders: {
      "X-Remote-User": "igor.mustac@uzh.ch",
      "X-Display-Name": "Igor Mustac",
      "X-Edu-Person-Unique-Id": "553131353436323302@uzh.ch",
      "X-Home-Organization": "uzh.ch",
      "X-Schac-Home-Organization": "uzh.ch",
      "X-Persistent-Id": "https://aai-idp.uzh.ch/idp/shibboleth!https://liri.linguistik.uzh.ch/shibboleth!O7bJIkf8gJ9QnxHUi4aIyJGRB+o=",
      "X-Given-Name": "Igor",
      "X-Surname": "Mustac",
      "X-Principal-Name": "553131353436323302@uzh.ch",
      "X-Mail": "igor.mustac@uzh.ch",
      "X-Shib-Identity-Provider": "https://aai-idp.uzh.ch/idp/shibboleth",
    },
    sentryDSN: null,
    editable: editable,
    staticData: staticData,
    dataSource: staticData ? 'static' : 'backend',
    // editable: false,
  }
}

export default config
